import { render, staticRenderFns } from "./StatsNavigation.vue?vue&type=template&id=17c7ace6&scoped=true&"
import script from "./StatsNavigation.vue?vue&type=script&lang=js&"
export * from "./StatsNavigation.vue?vue&type=script&lang=js&"
import style0 from "./StatsNavigation.vue?vue&type=style&index=0&id=17c7ace6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c7ace6",
  null
  
)

export default component.exports